import React from 'react';

export const IconWatcher = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.9168 11.6667L16.6668 7.50001C16.6668 7.50001 16.2502 5.83334 14.5835 5.83334C14.5835 5.83334 14.5835 4.16667 12.9168 4.16667C11.2502 4.16667 11.2502 5.83334 11.2502 5.83334H8.75016C8.75016 5.83334 8.75016 4.16667 7.0835 4.16667C5.41683 4.16667 5.41683 5.83334 5.41683 5.83334C3.75016 5.83334 3.3335 7.50001 3.3335 7.50001L2.0835 11.6667"
                stroke="#252733"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.00008 16.6667C5.88414 16.6667 6.73198 16.3155 7.3571 15.6904C7.98223 15.0652 8.33341 14.2174 8.33341 13.3333C8.33341 12.4493 7.98223 11.6014 7.3571 10.9763C6.73198 10.3512 5.88414 10 5.00008 10C4.11603 10 3.26818 10.3512 2.64306 10.9763C2.01794 11.6014 1.66675 12.4493 1.66675 13.3333C1.66675 14.2174 2.01794 15.0652 2.64306 15.6904C3.26818 16.3155 4.11603 16.6667 5.00008 16.6667ZM15.0001 16.6667C15.8841 16.6667 16.732 16.3155 17.3571 15.6904C17.9822 15.0652 18.3334 14.2174 18.3334 13.3333C18.3334 12.4493 17.9822 11.6014 17.3571 10.9763C16.732 10.3512 15.8841 10 15.0001 10C14.116 10 13.2682 10.3512 12.6431 10.9763C12.0179 11.6014 11.6667 12.4493 11.6667 13.3333C11.6667 14.2174 12.0179 15.0652 12.6431 15.6904C13.2682 16.3155 14.116 16.6667 15.0001 16.6667Z"
                stroke="#252733"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.0002 13.3333C10.4422 13.3333 10.8661 13.1577 11.1787 12.8452C11.4912 12.5326 11.6668 12.1087 11.6668 11.6667C11.6668 11.2246 11.4912 10.8007 11.1787 10.4882C10.8661 10.1756 10.4422 10 10.0002 10C9.55814 10 9.13421 10.1756 8.82165 10.4882C8.50909 10.8007 8.3335 11.2246 8.3335 11.6667C8.3335 12.1087 8.50909 12.5326 8.82165 12.8452C9.13421 13.1577 9.55814 13.3333 10.0002 13.3333Z"
                stroke="#252733"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
